import { getDefaultExportFromCjs as p } from "../../../../../../../_virtual/_commonjsHelpers.js";
function i() {
  return i = Object.assign ? Object.assign.bind() : function (o) {
    for (var e, n = 1; n < arguments.length; n++) for (var r in e = arguments[n], e) Object.prototype.hasOwnProperty.call(e, r) && (o[r] = e[r]);
    return o;
  }, i.apply(this, arguments);
}
var g = ["attrs", "props", "domProps"],
  m = ["class", "style", "directives"],
  v = ["on", "nativeOn"],
  y = function y(o) {
    return o.reduce(function (e, n) {
      for (var r in n) if (!e[r]) e[r] = n[r];else if (g.indexOf(r) !== -1) e[r] = i({}, e[r], n[r]);else if (m.indexOf(r) !== -1) {
        var a = e[r] instanceof Array ? e[r] : [e[r]],
          u = n[r] instanceof Array ? n[r] : [n[r]];
        e[r] = [].concat(a, u);
      } else if (v.indexOf(r) !== -1) {
        for (var t in n[r]) if (e[r][t]) {
          var f = e[r][t] instanceof Array ? e[r][t] : [e[r][t]],
            l = n[r][t] instanceof Array ? n[r][t] : [n[r][t]];
          e[r][t] = [].concat(f, l);
        } else e[r][t] = n[r][t];
      } else if (r === "hook") for (var s in n[r]) e[r][s] = e[r][s] ? O(e[r][s], n[r][s]) : n[r][s];else e[r] = n[r];
      return e;
    }, {});
  },
  O = function O(o, e) {
    return function () {
      o && o.apply(this, arguments), e && e.apply(this, arguments);
    };
  },
  d = y;
var x = /* @__PURE__ */p(d);
export { x as default };
